<template>

  <div>

    <div class="mx-auto" v-if=loading>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div> 
  </div>

    <div v-if=verify >

    <div id="mainpage">
       <slot name="customer"  > </slot>
     <!-- <button style="float: right" v-on:click="signout" class="btn btn-secondary">
         signout
    </button> -->
     <FlashMessage :position="'right top'"/>
  <div class="container">
    <div class="title display-4 font-weight-normal "> User Profile</div>
     <!-- <button id="submit" class="btn btn-secondary " style="float:right"  v-on:click.prevent="deleting" >  delete </button> -->
    <form>
        <div class="text-center m-3"  >
          <div v-if="this.$store.state.photourl">
            <img
            :src=this.$store.state.photourl
            class="shadow bg-white rounded" 
            id="img"
            alt="profile pic"
          />
          </div>
          <div v-else  >  
          <img
            src="https://info-ted.eu/wp-content/uploads/2019/12/profile-photo.png"
            class="rounded"
            alt="profile pic"
          />
          </div>
            <div v-if="this.$store.state.photourl">
              <button style="border:none;float:botton " v-on:click.prevent="deletephoto" > X </button>
            </div>
        </div>
        
      <div class="form-row" >
      
        <div class="form-group col-md-6 ">
          <label> username </label>
          <div v-if="this.$store.state.displayName" >  
          <input
          disabled
            type="text"
            class="form-control"
            placeholder="enter your username"
           :value='this.$store.state.displayName'
          />
          </div>
          <div v-else >
            <input
            type="text"
            class="form-control"
            placeholder="enter your username"
            v-model="username"
          />
          </div>
        </div>

        <div  class="form-group col-md-6"  >
            <label> Phone number </label>

            <div v-if="this.$store.state.phonenumber">
            <input
            disabled
            type="text"
            class="form-control"
            placeholder="enter your phone number"
            v-model="this.$store.state.phonenumber"
          />
            </div>

          <div v-else >  
          <input
            type="text"
            class="form-control"
            placeholder="enter your phone number ex:- 9655537630"
            v-model="phonenumber"
          />
          </div>

        </div>
      </div>

        <div class="form-row" >
 
        <div class="form-group col-md-6 ">
          <label> email </label>
          <div v-if="this.$store.state.email" >  
          <input
            disabled
            type="text"
            class="form-control"
            placeholder="enter your email"
           :value="this.$store.state.email"
          />
          </div>
          
          <div v-else > 
            <input
            type="text"
            class="form-control"
            placeholder="enter your email"
            v-model="email"
          />
          </div>
        </div>


        <div class="form-group col-md-6 ">
          <label> select pg\hostel  </label>
          <div  v-if="this.$store.state.pgname" >
          <input
            disabled
            type="text"
            class="form-control"
            placeholder="select the pg\hostel"
            v-model="this.$store.state.pgname"
          />
          </div>
          <div v-else >  
            <select class="custom-select" v-model="pgname"  >
              <option value="" > select the pg  </option>
              <option v-for=" (pg,index)  in this.$store.state.pgnames" v-bind:key="index" > {{pg.name}}  </option>

            </select>

           </div>
        </div>

      </div>
    
    <div class="form-row">  

         <div class="form-group col-md-6">
          <label> age  </label>
          
          <div v-if="this.$store.state.age" > 
            <input
            type="text"
            disabled
            class="form-control"
            placeholder="select the age"
            v-model="this.$store.state.age"
          />
          </div>
          <div v-else >  <input
            type="text"
            class="form-control"
            placeholder="select the age"
            v-model="age"
          /> </div>
         
        </div>

        <div class="form-group col-md-6">
          <label> select gender </label>
        
          <div  v-if="this.$store.state.gender" >  
           <select  class="custom-select" disabled  v-model="this.$store.state.gender">
                <option value="men"> Men </option>
                <option value="women"> Woman </option>
                <option value="other"> other </option>
            </select>
          </div>

          <div v-else > 
            <select  class="custom-select"  v-model="gender">
                <option value="men"> Men </option>
                <option value="women"> Woman </option>
                <option value="other"> other </option>
            </select>
          </div>
        </div>
    </div>

        <div  class="form-group">
        <label> Update your Profile  :-  </label>
          <!-- <input type="file" class="form-control-file"   @change="file" /> -->


            <image-uploader
            type=file
             :preview=false
            capture="environment"
            :debug="1"
            doNotResize="gif"
            :autoRotate="true"
            outputFormat="verbose"
            :className="['fileinput', { 'fileinput--loaded' : hasImage }]"
            @input="file"
          >
        </image-uploader>

        </div>

        <p v-show="uploadValue"> uploading photo:- {{uploadValue}}% </p>
       

        <button id="submit" class="btn btn-secondary btn-md btn-block" v-on:click.prevent= posting(username,phonenumber,pgname,gender,age,email,owner) >   submit </button>
       
        <!-- <button id="submit" class="btn btn-secondary btn-md btn-block" v-on:click.prevent="deletingaccount" >  delete account </button> -->
        <button id="submit" class="btn btn-secondary btn-md btn-block"  v-on:click.prevent="deleting" >  delete </button>
    </form>
  </div>

  </div>

  </div>

    <div  v-else-if="!verify && !loading" >

    <div class="container" >
      
    <div  class="row" >
    <div style="margin-top:200px"  class="col-md-6 mx-auto"  >
          Unique ID:- 
          <input type="text" placeholder="enter the unique id" class="form-control" v-model="uniqueid" >
          
          <button class="btn btn-secondary mx-auto my-1" v-on:click="code"  > submit </button>
          <br>
          {{this.dummyinfo}}
          <br>
           <p class="mx-auto"  style="text-align:center" > Note:- please contact your owner for more information    </p>
        </div>
        
        </div>

       
    </div>


    </div>

</div>

</template>
<script>

import {fb} from '../firebase';
import axios from 'axios'
export default {
  data() {
    return {
      dummyinfo:'',
      owner:'',
      username: "",
      phonenumber: "",
      phonenumber1: "",
      isAdmin:false,
      email:'',
      pgname:'',
      pgname1:'',
      imageurl:'',
      gender:'',
      age:'',
      gender1:'',
      age1:'',
      mainselectfile:'',
      uploadValue:'',
      allusers:'',
      pk_id:'',
      hasImage:false,
      name1:'',
      img:'',
      verify:false,
      loading:false,
      uniqueid:'',
    };
  },

  methods: {
     code:async function(){
        for(let obj in this.$store.state.pgnames)
        { 
          if(this.$store.state.pgnames[obj].code==this.uniqueid && this.$store.state.pgnames[obj].code!='')
            {
              this.verify= true
              await axios.post("https://pg-v1.herokuapp.com/post/verifyuser",{
                uid:localStorage.getItem('localid'),
                email:this.$store.state.email,
                verified:true,
              })
              .then(res=>{
                console.log(res)
                this.dummyinfo="please wait sometime, we are processing....."
                })
              .catch(err=>console.log(err))
             
            }
            else{
              this.dummyinfo="sorry please try again "   
            }
        }
    },


    signout:function(){
      localStorage.removeItem("email");
      localStorage.removeItem("password");
      localStorage.removeItem("localid");
      localStorage.removeItem("idtoken");
      localStorage.removeItem("id");
      this.$router.push('/login')
    },

    deletingaccount:function(){
      axios.post('https://pg-v1.herokuapp.com/deleteaccount/user',{
        uid:localStorage.getItem('localid'),
        id:this.$store.state.id
      })
      .then(res=>{
        console.log(res)
          this.flashMessage.setStrategy('single');
          this.flashMessage.success({
          message: res.data.message,
          time: 3000,
          blockClass: 'custom-block-class'
          });
          this.signout()
        })
      .catch(err=>{
        console.log(err)
         this.flashMessage.setStrategy('single');
          this.flashMessage.error({
          message: err.response.data.message,
          time: 6000,
          blockClass: 'custom-block-class'
          });
        })
    },

    deletephoto:function(){
      axios
      .post("https://pg-v1.herokuapp.com/deletephoto/user", {
        uid: localStorage.getItem("localid"),
        id: this.$store.state.id,
        photourl: null,
      })
      .then((res) => {
        console.log(res.data)
        location.reload()
        })
      .catch((err) => console.log(err));
    },

    deleting(){
      axios
        .delete("https://pg-v1.herokuapp.com/delete/user/" + this.$store.state.id)
        .then((res) => {
          console.log(res);
          location.reload();
        })
        .catch((err) => console.log(err));
    },

    file:function(obj){
      this.hasImage = true;
      this.img = obj.dataUrl;
      this.name1=obj.info.name
    },




    posting: function (
      username,
      phonenumber,
      pgname,
      gender,
      age,
      email,
      owner
    ) {
        
      email = this.$store.state.email;
      owner = this.$store.state.owner;
      if (
        this.$store.state.displayName == "" &&
        this.$store.state.pgname == "" &&
        this.$store.state.phonenumber =="" &&
        this.$store.state.gender=="" 
      ) {
        if(username!="" &&  phonenumber.trim().length==10 && pgname!="" && gender!="" && age!=""  && this.img!="")
        {
          this.flashMessage.setStrategy('single');
          this.flashMessage.success({
          message: 'successfully registered',
          time: 3000,
          blockClass: 'custom-block-class'
          });
          console.log('please enter valid data')
        }else{
          this.flashMessage.setStrategy('single');
          this.flashMessage.error({
          message: 'please complete all details',
          time: 3000,
          blockClass: 'custom-block-class'
          });
          console.log('please enter valid data')

          if(phonenumber.trim().length!=10)
          {
          this.flashMessage.setStrategy('single');
          this.flashMessage.error({
          message: 'phone number must be 10 digits ex:- 9655537630',
          time: 3000,
          blockClass: 'custom-block-class'
          });
          console.log('please enter valid data')
          }
        }
        var storageRef = fb
          .storage()
          .ref("userprofile/" + this.name1);
        let uploadedTask = storageRef.putString(this.img,'data_url');
        uploadedTask.on(
          "state_changed",
          (snapshot) => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          function (err) {
            console.log(err);
          },

          function () {
            uploadedTask.snapshot.ref
              .getDownloadURL()
              .then(async function (downloadURL) {
                await console.log(downloadURL);

                console.log('primary')
              if(username!="" &&  phonenumber.trim().length==10 && pgname!="" && gender!="" && age!="" )
              {  
                axios
                  .post("https://pg-v1.herokuapp.com/post/user", {
                    uid: localStorage.getItem("localid"),
                    username: username,
                    email: email,
                    phonenumber: phonenumber,
                    pgname: pgname,
                    gender: gender,
                    age: age,
                    owner: owner,
                    profilepic: downloadURL,
                  })
                  .then((res) => {
                    console.log(res);
                    location.reload();
                  })
                  .catch((err) => console.log(err));
              }
              });
          }
        );
      } else if(this.img!="") {
        var storageRef1 = fb
          .storage()
          .ref("userprofile/" + this.name1);
        let uploadedTask = storageRef1.putString(this.img,'data_url');
        uploadedTask.on(
          "state_changed",
          (snapshot) => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          function (err) {
            console.log(err);
          },

          function () {
            uploadedTask.snapshot.ref
              .getDownloadURL()
              .then(async function (downloadURL) {
                await console.log(downloadURL);

                axios
                  .post("https://pg-v1.herokuapp.com/deletephoto/user", {
                    uid:localStorage.getItem('localid'),
                    id: localStorage.getItem('id'),
                    photourl: downloadURL,
                  })
                  .then((res) => {
                    console.log(res);
                    location.reload()
                    console.log("updated the photo");
                  })
                  .catch((err) => console.log(err));
              });
          }
        );
      }
      else{
        this.flashMessage.setStrategy('single');
        this.flashMessage.info({
        message: 'please enter all input datas',
        time: 3000,
        blockClass: 'custom-block-class'
      });
        console.log('please enter valid data')
      }
    },



  },

  async created() {

    this.loading=true
    await axios.get('https://pg-v1.herokuapp.com/get/verifyuser')
    .then((res)=>{
      let datas= res.data
      for(let obj1 in datas)
      {
        if( datas[obj1].uid == localStorage.getItem('localid'))
        {
          this.verify=datas[obj1].verified
        }
        else{
          console.log("failed try again")
        }
      }
      this.loading=false
    })
    .catch((err)=>console.log(err))



    if (localStorage.getItem("localid")) {
      await this.$store.dispatch("getuseraction");
      await this.$store.dispatch("profileaction");
    }

    axios
      .post("https://pg-v1.herokuapp.com/getcurrentuser", {
        uid: localStorage.getItem("localid"),
      })
      .then((res) => {
        console.log(res.data);
        if (!res) {
          console.log("user: error in user or user not signin");
        }
      })
      .catch((err) => console.log(err));

      this.$store.dispatch('getpgnames')

  },

};
</script>

<style scoped >
.title {
  text-align: center;
  font-family: 'Google Sans','Roboto',Arial,sans-serif,Helvetica;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-left: auto;
  color: #2c3e50;
 padding-top: 50px;
  text-transform: capitalize;
}

#submit{
    margin: auto;
    margin-bottom: 20px;
}

#img {
  width: 200px;
  border-radius: 50%;
}

.container {
  text-transform: capitalize;
}



#mainpage{
    background-color: #e2dfe7;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='260' height='260' viewBox='0 0 260 260'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.18'%3E%3Cpath d='M24.37 16c.2.65.39 1.32.54 2H21.17l1.17 2.34.45.9-.24.11V28a5 5 0 0 1-2.23 8.94l-.02.06a8 8 0 0 1-7.75 6h-20a8 8 0 0 1-7.74-6l-.02-.06A5 5 0 0 1-17.45 28v-6.76l-.79-1.58-.44-.9.9-.44.63-.32H-20a23.01 23.01 0 0 1 44.37-2zm-36.82 2a1 1 0 0 0-.44.1l-3.1 1.56.89 1.79 1.31-.66a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .86.02l2.88-1.27a3 3 0 0 1 2.43 0l2.88 1.27a1 1 0 0 0 .85-.02l3.1-1.55-.89-1.79-1.42.71a3 3 0 0 1-2.56.06l-2.77-1.23a1 1 0 0 0-.4-.09h-.01a1 1 0 0 0-.4.09l-2.78 1.23a3 3 0 0 1-2.56-.06l-2.3-1.15a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1L.9 19.22a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01zm0-2h-4.9a21.01 21.01 0 0 1 39.61 0h-2.09l-.06-.13-.26.13h-32.31zm30.35 7.68l1.36-.68h1.3v2h-36v-1.15l.34-.17 1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0L2.26 23h2.59l1.36.68a3 3 0 0 0 2.56.06l1.67-.74h3.23l1.67.74a3 3 0 0 0 2.56-.06zM-13.82 27l16.37 4.91L18.93 27h-32.75zm-.63 2h.34l16.66 5 16.67-5h.33a3 3 0 1 1 0 6h-34a3 3 0 1 1 0-6zm1.35 8a6 6 0 0 0 5.65 4h20a6 6 0 0 0 5.66-4H-13.1z'/%3E%3Cpath id='path6_fill-copy' d='M284.37 16c.2.65.39 1.32.54 2H281.17l1.17 2.34.45.9-.24.11V28a5 5 0 0 1-2.23 8.94l-.02.06a8 8 0 0 1-7.75 6h-20a8 8 0 0 1-7.74-6l-.02-.06a5 5 0 0 1-2.24-8.94v-6.76l-.79-1.58-.44-.9.9-.44.63-.32H240a23.01 23.01 0 0 1 44.37-2zm-36.82 2a1 1 0 0 0-.44.1l-3.1 1.56.89 1.79 1.31-.66a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .86.02l2.88-1.27a3 3 0 0 1 2.43 0l2.88 1.27a1 1 0 0 0 .85-.02l3.1-1.55-.89-1.79-1.42.71a3 3 0 0 1-2.56.06l-2.77-1.23a1 1 0 0 0-.4-.09h-.01a1 1 0 0 0-.4.09l-2.78 1.23a3 3 0 0 1-2.56-.06l-2.3-1.15a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01zm0-2h-4.9a21.01 21.01 0 0 1 39.61 0h-2.09l-.06-.13-.26.13h-32.31zm30.35 7.68l1.36-.68h1.3v2h-36v-1.15l.34-.17 1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.56.06l1.67-.74h3.23l1.67.74a3 3 0 0 0 2.56-.06zM246.18 27l16.37 4.91L278.93 27h-32.75zm-.63 2h.34l16.66 5 16.67-5h.33a3 3 0 1 1 0 6h-34a3 3 0 1 1 0-6zm1.35 8a6 6 0 0 0 5.65 4h20a6 6 0 0 0 5.66-4H246.9z'/%3E%3Cpath d='M159.5 21.02A9 9 0 0 0 151 15h-42a9 9 0 0 0-8.5 6.02 6 6 0 0 0 .02 11.96A8.99 8.99 0 0 0 109 45h42a9 9 0 0 0 8.48-12.02 6 6 0 0 0 .02-11.96zM151 17h-42a7 7 0 0 0-6.33 4h54.66a7 7 0 0 0-6.33-4zm-9.34 26a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-4.34a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-4.34a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-7a7 7 0 1 1 0-14h42a7 7 0 1 1 0 14h-9.34zM109 27a9 9 0 0 0-7.48 4H101a4 4 0 1 1 0-8h58a4 4 0 0 1 0 8h-.52a9 9 0 0 0-7.48-4h-42z'/%3E%3Cpath d='M39 115a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm6-8a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-3-29v-2h8v-6H40a4 4 0 0 0-4 4v10H22l-1.33 4-.67 2h2.19L26 130h26l3.81-40H58l-.67-2L56 84H42v-6zm-4-4v10h2V74h8v-2h-8a2 2 0 0 0-2 2zm2 12h14.56l.67 2H22.77l.67-2H40zm13.8 4H24.2l3.62 38h22.36l3.62-38z'/%3E%3Cpath d='M129 92h-6v4h-6v4h-6v14h-3l.24 2 3.76 32h36l3.76-32 .24-2h-3v-14h-6v-4h-6v-4h-8zm18 22v-12h-4v4h3v8h1zm-3 0v-6h-4v6h4zm-6 6v-16h-4v19.17c1.6-.7 2.97-1.8 4-3.17zm-6 3.8V100h-4v23.8a10.04 10.04 0 0 0 4 0zm-6-.63V104h-4v16a10.04 10.04 0 0 0 4 3.17zm-6-9.17v-6h-4v6h4zm-6 0v-8h3v-4h-4v12h1zm27-12v-4h-4v4h3v4h1v-4zm-6 0v-8h-4v4h3v4h1zm-6-4v-4h-4v8h1v-4h3zm-6 4v-4h-4v8h1v-4h3zm7 24a12 12 0 0 0 11.83-10h7.92l-3.53 30h-32.44l-3.53-30h7.92A12 12 0 0 0 130 126z'/%3E%3Cpath d='M212 86v2h-4v-2h4zm4 0h-2v2h2v-2zm-20 0v.1a5 5 0 0 0-.56 9.65l.06.25 1.12 4.48a2 2 0 0 0 1.94 1.52h.01l7.02 24.55a2 2 0 0 0 1.92 1.45h4.98a2 2 0 0 0 1.92-1.45l7.02-24.55a2 2 0 0 0 1.95-1.52L224.5 96l.06-.25a5 5 0 0 0-.56-9.65V86a14 14 0 0 0-28 0zm4 0h6v2h-9a3 3 0 1 0 0 6H223a3 3 0 1 0 0-6H220v-2h2a12 12 0 1 0-24 0h2zm-1.44 14l-1-4h24.88l-1 4h-22.88zm8.95 26l-6.86-24h18.7l-6.86 24h-4.98zM150 242a22 22 0 1 0 0-44 22 22 0 0 0 0 44zm24-22a24 24 0 1 1-48 0 24 24 0 0 1 48 0zm-28.38 17.73l2.04-.87a6 6 0 0 1 4.68 0l2.04.87a2 2 0 0 0 2.5-.82l1.14-1.9a6 6 0 0 1 3.79-2.75l2.15-.5a2 2 0 0 0 1.54-2.12l-.19-2.2a6 6 0 0 1 1.45-4.46l1.45-1.67a2 2 0 0 0 0-2.62l-1.45-1.67a6 6 0 0 1-1.45-4.46l.2-2.2a2 2 0 0 0-1.55-2.13l-2.15-.5a6 6 0 0 1-3.8-2.75l-1.13-1.9a2 2 0 0 0-2.5-.8l-2.04.86a6 6 0 0 1-4.68 0l-2.04-.87a2 2 0 0 0-2.5.82l-1.14 1.9a6 6 0 0 1-3.79 2.75l-2.15.5a2 2 0 0 0-1.54 2.12l.19 2.2a6 6 0 0 1-1.45 4.46l-1.45 1.67a2 2 0 0 0 0 2.62l1.45 1.67a6 6 0 0 1 1.45 4.46l-.2 2.2a2 2 0 0 0 1.55 2.13l2.15.5a6 6 0 0 1 3.8 2.75l1.13 1.9a2 2 0 0 0 2.5.8zm2.82.97a4 4 0 0 1 3.12 0l2.04.87a4 4 0 0 0 4.99-1.62l1.14-1.9a4 4 0 0 1 2.53-1.84l2.15-.5a4 4 0 0 0 3.09-4.24l-.2-2.2a4 4 0 0 1 .97-2.98l1.45-1.67a4 4 0 0 0 0-5.24l-1.45-1.67a4 4 0 0 1-.97-2.97l.2-2.2a4 4 0 0 0-3.09-4.25l-2.15-.5a4 4 0 0 1-2.53-1.84l-1.14-1.9a4 4 0 0 0-5-1.62l-2.03.87a4 4 0 0 1-3.12 0l-2.04-.87a4 4 0 0 0-4.99 1.62l-1.14 1.9a4 4 0 0 1-2.53 1.84l-2.15.5a4 4 0 0 0-3.09 4.24l.2 2.2a4 4 0 0 1-.97 2.98l-1.45 1.67a4 4 0 0 0 0 5.24l1.45 1.67a4 4 0 0 1 .97 2.97l-.2 2.2a4 4 0 0 0 3.09 4.25l2.15.5a4 4 0 0 1 2.53 1.84l1.14 1.9a4 4 0 0 0 5 1.62l2.03-.87zM152 207a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm6 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-11 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm3-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-8 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm3 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm5-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm5 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4-6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm6-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-4-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-5-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-24 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm16 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm7-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm86-29a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm19 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-14 5a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-25 1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm5 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm9 0a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm15 1a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm12-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-11-14a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-19 0a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm6 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-25 15c0-.47.01-.94.03-1.4a5 5 0 0 1-1.7-8 3.99 3.99 0 0 1 1.88-5.18 5 5 0 0 1 3.4-6.22 3 3 0 0 1 1.46-1.05 5 5 0 0 1 7.76-3.27A30.86 30.86 0 0 1 246 184c6.79 0 13.06 2.18 18.17 5.88a5 5 0 0 1 7.76 3.27 3 3 0 0 1 1.47 1.05 5 5 0 0 1 3.4 6.22 4 4 0 0 1 1.87 5.18 4.98 4.98 0 0 1-1.7 8c.02.46.03.93.03 1.4v1h-62v-1zm.83-7.17a30.9 30.9 0 0 0-.62 3.57 3 3 0 0 1-.61-4.2c.37.28.78.49 1.23.63zm1.49-4.61c-.36.87-.68 1.76-.96 2.68a2 2 0 0 1-.21-3.71c.33.4.73.75 1.17 1.03zm2.32-4.54c-.54.86-1.03 1.76-1.49 2.68a3 3 0 0 1-.07-4.67 3 3 0 0 0 1.56 1.99zm1.14-1.7c.35-.5.72-.98 1.1-1.46a1 1 0 1 0-1.1 1.45zm5.34-5.77c-1.03.86-2 1.79-2.9 2.77a3 3 0 0 0-1.11-.77 3 3 0 0 1 4-2zm42.66 2.77c-.9-.98-1.87-1.9-2.9-2.77a3 3 0 0 1 4.01 2 3 3 0 0 0-1.1.77zm1.34 1.54c.38.48.75.96 1.1 1.45a1 1 0 1 0-1.1-1.45zm3.73 5.84c-.46-.92-.95-1.82-1.5-2.68a3 3 0 0 0 1.57-1.99 3 3 0 0 1-.07 4.67zm1.8 4.53c-.29-.9-.6-1.8-.97-2.67.44-.28.84-.63 1.17-1.03a2 2 0 0 1-.2 3.7zm1.14 5.51c-.14-1.21-.35-2.4-.62-3.57.45-.14.86-.35 1.23-.63a2.99 2.99 0 0 1-.6 4.2zM275 214a29 29 0 0 0-57.97 0h57.96zM72.33 198.12c-.21-.32-.34-.7-.34-1.12v-12h-2v12a4.01 4.01 0 0 0 7.09 2.54c.57-.69.91-1.57.91-2.54v-12h-2v12a1.99 1.99 0 0 1-2 2 2 2 0 0 1-1.66-.88zM75 176c.38 0 .74-.04 1.1-.12a4 4 0 0 0 6.19 2.4A13.94 13.94 0 0 1 84 185v24a6 6 0 0 1-6 6h-3v9a5 5 0 1 1-10 0v-9h-3a6 6 0 0 1-6-6v-24a14 14 0 0 1 14-14 5 5 0 0 0 5 5zm-17 15v12a1.99 1.99 0 0 0 1.22 1.84 2 2 0 0 0 2.44-.72c.21-.32.34-.7.34-1.12v-12h2v12a3.98 3.98 0 0 1-5.35 3.77 3.98 3.98 0 0 1-.65-.3V209a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-24c.01-1.53-.23-2.88-.72-4.17-.43.1-.87.16-1.28.17a6 6 0 0 1-5.2-3 7 7 0 0 1-6.47-4.88A12 12 0 0 0 58 185v6zm9 24v9a3 3 0 1 0 6 0v-9h-6z'/%3E%3Cpath d='M-17 191a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm19 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1zm-14 5a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-25 1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm5 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm9 0a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm15 1a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm12-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2H4zm-11-14a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-19 0a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm6 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-25 15c0-.47.01-.94.03-1.4a5 5 0 0 1-1.7-8 3.99 3.99 0 0 1 1.88-5.18 5 5 0 0 1 3.4-6.22 3 3 0 0 1 1.46-1.05 5 5 0 0 1 7.76-3.27A30.86 30.86 0 0 1-14 184c6.79 0 13.06 2.18 18.17 5.88a5 5 0 0 1 7.76 3.27 3 3 0 0 1 1.47 1.05 5 5 0 0 1 3.4 6.22 4 4 0 0 1 1.87 5.18 4.98 4.98 0 0 1-1.7 8c.02.46.03.93.03 1.4v1h-62v-1zm.83-7.17a30.9 30.9 0 0 0-.62 3.57 3 3 0 0 1-.61-4.2c.37.28.78.49 1.23.63zm1.49-4.61c-.36.87-.68 1.76-.96 2.68a2 2 0 0 1-.21-3.71c.33.4.73.75 1.17 1.03zm2.32-4.54c-.54.86-1.03 1.76-1.49 2.68a3 3 0 0 1-.07-4.67 3 3 0 0 0 1.56 1.99zm1.14-1.7c.35-.5.72-.98 1.1-1.46a1 1 0 1 0-1.1 1.45zm5.34-5.77c-1.03.86-2 1.79-2.9 2.77a3 3 0 0 0-1.11-.77 3 3 0 0 1 4-2zm42.66 2.77c-.9-.98-1.87-1.9-2.9-2.77a3 3 0 0 1 4.01 2 3 3 0 0 0-1.1.77zm1.34 1.54c.38.48.75.96 1.1 1.45a1 1 0 1 0-1.1-1.45zm3.73 5.84c-.46-.92-.95-1.82-1.5-2.68a3 3 0 0 0 1.57-1.99 3 3 0 0 1-.07 4.67zm1.8 4.53c-.29-.9-.6-1.8-.97-2.67.44-.28.84-.63 1.17-1.03a2 2 0 0 1-.2 3.7zm1.14 5.51c-.14-1.21-.35-2.4-.62-3.57.45-.14.86-.35 1.23-.63a2.99 2.99 0 0 1-.6 4.2zM15 214a29 29 0 0 0-57.97 0h57.96z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
     height:270px;
}


@media only screen and (max-width: 600px) {
  .title {
    padding-top: 50px;
    margin-bottom: 35px;
    text-align: center;
    font-size: 2em;
    font-family: "Google Sans", "Roboto", Arial, sans-serif, Helvetica;
  }

  
}


@media only screen and (max-width: 767px) {
  .title {
    padding-top: 50px;
    margin-bottom: 35px;
    text-align: center;
    font-size: 2em;
    font-family: "Google Sans", "Roboto", Arial, sans-serif, Helvetica;
  }

  
}

.spinner-grow{
  position: fixed;
  left: 0px;
  top: 25%;
  width: 100%;
  height: 50%;
  z-index: 9999;
  background: url('//upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Phi_fenomeni.gif/50px-Phi_fenomeni.gif') 
              50% 50% no-repeat rgb(249,249,249);
}

</style>